// # Likes section component for profile
import React from 'react';
import './prfl_likes.css';

const ProfileLikes = ({ isDarkMode }) => {
  return (
    <div className={`prfl_likes_container ${isDarkMode ? 'prfl_dark-mode' : ''}`}>
      <div className="prfl_likes_coming-soon">
        <h3>Likes Feature Coming Soon</h3>
        <p>View posts and content you've liked across the platform.</p>
      </div>
    </div>
  );
};

export default ProfileLikes; 